import { t } from "../i18n/index.ts";
import { setSideShown, sideShown } from "../lib/itemSide.ts";
import { HideSideIcon, ShowSideIcon } from "./icons.tsx";
import { iconButtonClass } from "./styles.ts";

/** Hides or shows the panel beside an item's file (wide screens only: narrow, it's a tab of its own). */
export function SideToggle() {
  const on = sideShown.value;
  const label = t(on ? "item.hideSide" : "item.showSide");
  return (
    // Its own wrapper hides it on narrow screens (the button's display would win over `hidden` on it).
    <span class="hidden @3xl/main:inline-flex">
      <button
        type="button"
        class={iconButtonClass("sm")}
        aria-pressed={!on}
        aria-label={label}
        title={label}
        onClick={() => setSideShown(!on)}
      >
        {on ? <HideSideIcon /> : <ShowSideIcon />}
      </button>
    </span>
  );
}
